import { tv } from 'tailwind-variants'

export const buttonStyles = tv({
	base: 'group flex items-center w-fit justify-center web:transition-colors web:focus-visible:outline-none rounded-[0.3em] border-0 cursor-pointer',
	variants: {
		variant: {
			primary:
				'bg-palette_7 border border-palette_7 hover:bg-palette_8 hover:border-palette_8',
			secondary: 'bg-transparent border border-palette_6 hover:border-palette_8',
			tertiary: 'bg-transparent border border-palette_6 hover:border-palette_8',
			ghost: 'bg-transparent border-2 border-palette_6',
			ghostBorderless: 'bg-transparent',
		},
		size: {
			default: 'px-7 py-2.5',
			sm: 'px-6 py-1.5 text-[0.9em]',
			xs: 'px-6 py-1 text-[0.86em]',
			lg: 'px-7 py-2.5',
		},
		disabled: {
			true: '!border !border-inactive_1 !bg-transparent hover:!bg-transparent hover:!border-inactive_1 cursor-default',
		},
	},
	defaultVariants: {
		variant: 'primary',
		size: 'default',
		disabled: false,
	},
})

export const buttonTextStyles = tv({
	base: 'web:whitespace-nowrap font-primary font-normal tracking-[0.03em]',
	variants: {
		variant: {
			primary: 'text-white',
			secondary: 'text-palette_6 group-hover:text-palette_8',
			tertiary: 'text-palette_6 group-hover:text-palette_8 font-light',
			ghost: 'text-palette_6',
			ghostBorderless: 'text-palette_7',
		},
		size: {
			default: 'text-base',
			xs: 'text-xs',
			sm: 'text-sm',
			lg: 'text-xl',
		},
		disabled: {
			true: 'text-inactive_1',
		},
		spacing: {
			normal: 'tracking-[0.03em]',
			wide: 'tracking-[.15em]',
		},
		isLoading: {
			true: 'invisible',
		},
	},
	defaultVariants: {
		variant: 'primary',
		size: 'default',
		spacing: 'normal',
		disabled: false,
		isLoading: false,
	},
})
